define('commons/password-change',['jquery'], function($){
    var changePassword = function() {
        var regexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$=%^&*()_+}{":;'\-?/>.<\s,]).{12,100}$/;
        var iconPassword = $('#icon-password');
        var password = $('#password').val();
        var value = null;
        $('#password').keyup(function(ev) {
            password = $(ev.currentTarget).val();
            if (regexp.test(password)) {
                iconPassword.removeClass('icon-remove-circle error');
                iconPassword.addClass('icon-ok-circle ok');
                $('#password\\.errors').remove();
            } else {
                iconPassword.removeClass('icon-ok-circle ok');
                iconPassword.addClass('icon-remove-circle error');
            }
            if (value && value != null) {
                if (value == password && regexp.test(value)) {
                    iconConfirm.removeClass('icon-remove-circle error');
                    iconConfirm.addClass('icon-ok-circle ok');
                    $('#confirmPassword\\.errors').remove();
                } else {
                    iconConfirm.removeClass('icon-ok-circle ok');
                    iconConfirm.addClass('icon-remove-circle error');
                }
            }
        });
        var iconConfirm = $('#icon-confirm');
        $('#confirmPassword').keyup(function(ev) {
            value = $(ev.currentTarget).val();
            if (value == password && regexp.test(value)) {
                iconConfirm.removeClass('icon-remove-circle error');
                iconConfirm.addClass('icon-ok-circle ok');
                $('#confirmPassword\\.errors').remove();
            } else {
                iconConfirm.removeClass('icon-ok-circle ok');
                iconConfirm.addClass('icon-remove-circle error');
            }
        });
    };
    changePassword();
    return changePassword;
});
